var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeakmojo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 550 550",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_0",
    x1: 26.6128769,
    x2: 518.95166,
    y1: 188.508148,
    y2: 341.532166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(243,105,77)",
    offset: 0.144800007,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(243,112,82)",
    offset: 0.299400002,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(241,122,82)",
    offset: 0.472000003,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(243,128,78)",
    offset: 0.653199971,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(239,144,80)",
    offset: 0.838999987,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(237,170,72)",
    offset: 1,
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u77E2\\u91CF 21",
    d: "M113.604 459.473C113.604 459.473 66.274 382.611 170.386 281.618C242.574 209.423 230.085 163.323 236.883 174.988C243.68 186.654 253.492 251.65 181.533 349.88C103.054 478.91 208.942 544.972 256.856 549.778C257.828 549.875 258.348 548.655 257.649 547.974C245.467 536.109 187.966 473.734 245.315 403.306C294.378 346.315 265.666 269.981 273.156 269.981C280.647 269.981 300.096 286.415 331.993 346.314C373.661 456.009 306.766 531.596 291.354 547.067C290.592 547.832 291.351 549.193 292.388 548.894C360.998 529.081 382.96 459.506 382.96 459.506L540.681 459.506C547.975 459.506 552.423 451.34 548.597 445.041L281.432 4.47053C277.801 -1.49572 269.264 -1.49572 265.666 4.50387L1.3799 445.04C-2.41432 451.373 2.06681 459.473 9.32809 459.473L113.604 459.473Z",
    fill: "url(#paint_linear_0)",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeakmojo);
export default __webpack_public_path__ + "static/media/peakmojo.a22c70059004a16f2453555e4a6a06b7.svg";
export { ForwardRef as ReactComponent };